import {type Band} from 'uplot';

import {type DrawLine} from '../chartSeries';
import {parseLineColor} from '../lineUtils';
import {type SeriesById, type SeriesEntry} from './getSeriesEntries';

/** Pair each min/max band's two edges and choose the fill color between them. */
export function getBands(
  seriesEntries: (SeriesEntry<DrawLine> | null)[],
  seriesById: SeriesById
): Band[] {
  const bands: Band[] = [];

  seriesEntries.forEach((entry, idx) => {
    if (entry == null) {
      return;
    }
    const seriesIdx = idx;

    if (entry.type === 'band-max') {
      const indices = seriesById.get(entry.line.seriesId);
      if (indices == null) {
        return;
      }
      const bandMinSeriesIndex = indices.bandMinSeriesIndex;
      if (bandMinSeriesIndex == null) {
        return;
      }

      bands.push({
        series: [seriesIdx, bandMinSeriesIndex],
        fill: parseLineColor(entry.line.color).rgb().string(),
      });
    }
  });

  return bands;
}
